import { Flex } from '@radix-ui/themes';
import PageHeader from '../components/common/PageHeader';
import styles from './stubs.module.css';

function StubPage({ title }: { title: string }) {
  return (
    <Flex direction="column">
      <PageHeader title={title} />
      <p className={styles.comingSoon}>This page is coming soon.</p>
    </Flex>
  );
}

export function OverviewPage() { return <StubPage title="Overview" />; }
export function ClientsPage() { return <StubPage title="Clients" />; }
export function VendorsPage() { return <StubPage title="Vendors" />; }
export function SuppliersPage() { return <StubPage title="Suppliers" />; }
export function InvoicesPage() { return <StubPage title="Invoices" />; }
export function StatsPage() { return <StubPage title="Stats" />; }
export function EmbedSettingsPage() { return <StubPage title="Embed Settings" />; }
export function LaunchStatusPage() { return <StubPage title="Launch Status" />; }
export function DemoPage() { return <StubPage title="Demo Environment" />; }
export function LogsPage() { return <StubPage title="Logs" />; }
export function HelpPage() { return <StubPage title="Help Center" />; }
